import TtamAdFormatLeadAdType from './lead-ad-type/index.vue';
import TtamAdFormatNormalAdType from './normal-ad-type/index.vue';
import TtamAdFormatManualChooseHeader from './common/manually-choose-creatives.vue';
import TtamAdFormatCatalogChooseHeader from './common/catalog-chose-creatives.vue';

import * as hooks from './hooks';
export default {
  ...hooks,
  TtamAdFormatLeadAdType,
  TtamAdFormatNormalAdType,
  TtamAdFormatCatalogChooseHeader,
  TtamAdFormatManualChooseHeader,
};
